var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValidatorCountFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 39,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m19.667 32.599-9.334 5-9.333-5v-10l9.333-5 9.334 5v10zM41.667 32.599l-9.334 5-9.333-5v-10l9.333-5 9.334 5v10zM63.667 32.599l-9.334 5-9.333-5v-10l9.333-5 9.334 5v10zM85.667 32.599l-9.334 5-9.333-5v-10l9.333-5 9.334 5v10zM30.667 15.599l-9.334 5-9.333-5v-10l9.333-5 9.334 5v10zM52.667 15.599l-9.334 5-9.333-5v-10l9.333-5 9.334 5v10zM74.667 15.599l-9.334 5-9.333-5v-10l9.333-5 9.334 5v10z",
    stroke: "var(--positive)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidatorCountFilled);
export default __webpack_public_path__ + "static/media/validator-count-filled.6583c431102e92122a1176684f98173f.svg";
export { ForwardRef as ReactComponent };